/* global $ */
'use strict';

function SlickGallery(EVENTS, MODALS) {
	require('slick-carousel');

	var Handlebars = require('handlebars');
	var	PubSub = require('pubsub-js');
	var	photoEdit = require('./photoEdit.js');

	var	$slickElement = $('#horizontal-gallery');
	var	$pagerContainer = $('#horizontal-gallery-pager');
	var	$pager = $pagerContainer.find('span');
	var	slickCurrent = '.slick-current';
	var	$templateElem = $('#slider-gallery');
	var	visual = $.t('visual', {returnObjectTrees: true});
	var	data = composeData(visual);
	var	FRAME_SIZE = 900;

	function slickGoTo(msg, data) {
		$slickElement.slick('slickGoTo', data);
	}

	function bindEventsBefore() {
		$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			$pager.text(i + '/' + slick.slideCount);
			PubSub.publish(EVENTS.LAZYLOAD_SLICK, i);
		});
	}

	function bindEventsAfter() {
		$slickElement.on('setPosition', function (event, slick, currentSlide, nextSlide) {
			var curSlide = $(this).find(slickCurrent),
				curSlideSize = curSlide.width(),
				curSlideFrame = curSlide.find('.frame'),
				curSlideFrameParam = {
					width: curSlideFrame.data('width'),
					height: curSlideFrame.data('height'),
					top: curSlideFrame.data('top'),
					left: curSlideFrame.data('left')
				};
			PubSub.publish('cropSize', curSlideFrameParam);
			PubSub.publish(EVENTS.GALLERY_SIZE, curSlideSize);
			PubSub.publish(EVENTS.SLICK_TRACKING, curSlide);
			var curScale = curSlideSize / FRAME_SIZE;
			$('.cropit-wrapper').width(curSlideSize).height(curSlideSize);
			$('.cropit-container').css({transform: 'scale(' + curScale + ')', '-webkit-transform': 'scale(' + curScale + ')'});
		});
		PubSub.subscribe(EVENTS.SLICK_GOTO, slickGoTo);
		photoEdit(EVENTS, MODALS);
	}

	function composeData(data) {
		var result = {
			'slides': []
		};

		for (var prop in data) {
			if (data.hasOwnProperty(prop)) {
				result.slides.push({
					'src': data[prop].slick,
					'frame': data[prop].frame,
					'cropWidth': data[prop].cropWidth,
					'cropHeight': data[prop].cropHeight,
					'cropTop': data[prop].cropTop,
					'cropLeft': data[prop].cropLeft,
					'pngPack': data[prop].pngPack
				});
			}
		}

		return result;
	}

	function init() {
		bindEventsBefore();
		$slickElement.slick({
			slidesToShow: 1,
			swipe: false,
			appendArrows: $pagerContainer
		});
		bindEventsAfter();
	}

	if ($templateElem.length) {
		var template = Handlebars.compile($templateElem.html());
		$templateElem.remove();
		$slickElement.append(template(data));
		init();
	}

}

module.exports = SlickGallery;
